import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import MainPos2 from '../views/MainPos2.vue'
import Dashboard from '../views/Dashboard.vue'
import Customers from '../views/Customers.vue'
import DailyTotal from '../views/DailyTotal.vue'
import ItemsDaily from '../views/ItemsDaily.vue'
import AllItems from '../views/allItems.vue'
import DepItemsDaily from '../views/DepItemsDaily.vue'
import Reports from '../views/Reports.vue'
import GenReports from '../views/GenReports.vue'
import UnSyncedInvPage from '../views/UnSyncedInvPage.vue'
import GiftCards from '../views/GiftCards.vue'
import Settings from '../views/Settings.vue'
import ReturnInvoices from '../views/ReturnInvoices.vue'
import FindInvoice from '../views/FindInvoice.vue'
import Shifts from '../views/Shifts.vue'
import ProductManagement from '../views/ProductManagement.vue'
import ReturnProducts from '../views/ReturnProducts.vue'
import PageNotFound from '../views/PageNotFound.vue'
import DailySales from '../views/DailySales.vue'
import CashierCash from '../views/CashierCash.vue'
import CashierPayments from '../views/CashierPayments.vue'
import CashierInvoices from '../views/CashierInvoices.vue'
import Promotions from '../views/Promotions.vue'
import Users from '../views/Users.vue'
import UserPermissions from '../views/UserPermissions.vue'
import MainPage from '../views/MainPage.vue'
import Products from '../views/Products.vue'
import Machines from '../views/Machines.vue'
import MobilePaymentProviders from '../views/MobilePaymentProviders.vue'
import CustomCloseCash from '../views/CustomCloseCash.vue'
import ThemeSettings from '../views/ThemeSettings.vue'
import ThemeImagesSettings from '../views/ThemeImagesSettings.vue'
import GeneralSettings from '../views/GeneralSettings.vue'
import ParkedOrders from '../views/ParkedOrders.vue'
import ApiLogs from '../views/ApiLogs.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Login,
    meta: { title: 'login' }
  },
  {
    path: '/main',
    name: 'main',
    component: MainPos2,
    meta: { title: 'POS' }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { title: 'Dashboard' }
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: { title: 'Customers' }
  },
  {
    path: '/find/:invoiceNumber?',
    name: 'find',
    component: FindInvoice,
    meta: { title: 'Find Invoice' }
  },
  {
    path: '/parked',
    name: 'parked',
    component: ParkedOrders,
    meta: { title: 'Parked Orders' }
  },

  {
    path: '/dailytotal',
    name: 'dailytotal',
    component: DailyTotal,
    meta: { title: 'Daily Total' }
  },
  {
    path: '/itemsdaily',
    name: 'itemsdaily',
    component: ItemsDaily,
    meta: { title: 'Daily Sales' }
  },
  {
    path: '/allItems',
    name: 'allItems',
    component: AllItems,
    meta: { title: 'All Items' }
  },
  {
    path: '/itemsdepdaily',
    name: 'itemsdepdaily',
    component: DepItemsDaily,
    meta: { title: 'Daily Sales by Department' }
  },

  {
    path: '/cashiercash',
    name: 'cashiercash',
    component: CashierCash,
    meta: { title: 'Cashier Cash' }
  },

  {
    path: '/cashierpayments',
    name: 'cashierpayments',
    component: CashierPayments,
    meta: { title: 'Cashier Payments' }
  },
  {
    path: '/cashierinvoices',
    name: 'cashierinvoices',
    component: CashierInvoices,
    meta: { title: 'Cashier Invoices' }
  },
  {
    path: '/dailysales',
    name: 'dailysales',
    component: DailySales,
    meta: { title: 'Daily Sales' }
  },
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    meta: { title: 'Reports' }
  },
  {
    path: '/gen-reports/',
    name: 'Gen Reports',
    component: GenReports,
    meta: { title: 'General Reports' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { title: 'Settings' }
  },
  {
    path: '/theme_settings',
    name: 'theme_settings',
    component: ThemeSettings,
    meta: { title: 'Theme Settings' }
  },
  {
    path: '/theme_images_settings',
    name: 'theme_images_settings',
    component: ThemeImagesSettings,
    meta: { title: 'Settings' }
  },
  {
    path: '/general_settings',
    name: 'general_settings',
    component: GeneralSettings,
    meta: { title: 'Settings' }
  },
  {
    path: '/giftcards',
    name: 'giftcards',
    component: GiftCards,
    meta: { title: 'Gift' }
  },
  ,
  {
    path: '/shifts',
    name: 'shifts',
    component: Shifts,
    meta: { title: 'Shifts' }
  },

  {
    path: '/promotions',
    name: 'promotions',
    component: Promotions,
    meta: { title: 'Promotions' }
  },

  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: { title: 'Users' }
  },
  {
    path: '/users/:userId/permissions',
    name: 'user-permissions',
    component: UserPermissions,
    meta: { title: 'User Permissions' }
  },
  {
    path: '/products',
    name: 'products',
    component: Products,
    meta: { title: 'Products' }
  }
  ,
  {
    path: '/machines',
    name: 'machines',
    component: Machines,
    meta: { title: 'Machines' }
  },

  {
    path: '/mobile_payment_proivder',
    name: 'mobile_payment_proivder',
    component: MobilePaymentProviders,
    meta: { title: 'Mobile Provider' }
  },

  {
    path: '/sync_ura',
    name: 'sync_ura',
    component: UnSyncedInvPage,
    meta: { title: 'URA' }
  },
  {
    path: '/custom_close_cash',
    name: 'custom_close_cash',
    component: CustomCloseCash,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { title: 'Login' }
  },
  {
    path: '/product_management',
    name: 'product_management',
    component: ProductManagement,
    meta: { title: 'Product Management' }
  },
  {
    path: '/logs',
    name: 'logs',
    component: ApiLogs,
    meta: { title: 'Logs' }
  },
  {
    path: '/returns',
    name: 'returns',
    component: ReturnInvoices,
    meta: { title: 'Return Invoices' }
  },
  {
    path: '/prod_return',
    name: 'prod_return',
    component: ReturnProducts,
    meta: { title: 'Return Products' }
  },


  {
    path: '/:pathMatch(.*)*',
    name: 'not_found',
    component: PageNotFound,
    meta: { title: 'Page Not Found' }
  },
  { path: "/:pathMatch(.*)*", redirect: { name: "login" } },
  {
    path: "/:catchAll(.*)",
    name: 'not_found',
    component: PageNotFound,
    meta: { title: 'Page Not Found' }
  },

  {
    path: '/index',
    name: 'index',
    component: MainPage,
    meta: { title: 'Main Page' }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const last = Number(localStorage.getItem('lastActivity') || 0)
  const now = Date.now()
  const HoursMs = 60 * 60 * 1000
  if (last > 0 && now - last >= HoursMs) {
    localStorage.clear()
    if (to.name !== 'login') {
      next({ name: 'login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
    return
  }
  const loggedIn = !!localStorage.userId && !!localStorage.appId
  if (!loggedIn && to.name !== 'login') {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }
  if (loggedIn && (to.name === 'login' || to.path === '/')) {
    next({ name: 'dashboard' })
    return
  }
  next()
})

router.afterEach((to) => {
  const appTitle = 'Via Retail'
  const routeTitle = to.meta && to.meta.title ? to.meta.title : ''
  document.title = routeTitle ? `${routeTitle} - ${appTitle}` : appTitle
})

export default router
